import { del, get, post, put } from "../helpers/api_helper"

export const UserService = {

  getUsers: async () => {
    return get('/users');
  },

  getUsersAll: async () => {
    return get('/users/all');
  },

  getBuyerTeamLead: async () => {
    return get('/get-buyer-team-lead');
  },

  getUsersBuyerTeamLead: async () => {
    return get(`/get-users-buyer-team-lead`);
  },

  setFcmToken: async (data: any) => {
    return post(`/user/fcm-token`, data)
  },

  getUserPassword: async (data: any) => {
    return post(`/users/password`, data)
  },

  getTgAccounts: async () => {
    return get(`/accounts`)
  },
}